<script setup lang="ts">
import type { Product } from '@/types'
import { Head, Link } from '@inertiajs/vue3'
import ProductForm from '@/components/products/ProductForm.vue'
import { dashboardLayout } from '@/lib/layouts'
import { adminProductsPath } from '@/routes'

defineOptions({
  layout: dashboardLayout,
})

defineProps<{
  product: Partial<Product>
}>()

const title = 'New product'
</script>

<template>
  <Head :title="title" />

  <UDashboardPanel id="product-new">
    <template #header>
      <UDashboardNavbar :title="title">
        <template #leading>
          <UButton
            :to="adminProductsPath()"
            :as="Link"
            icon="i-lucide-arrow-left"
            color="neutral"
            variant="ghost"
            square
          />
        </template>
      </UDashboardNavbar>
    </template>

    <template #body>
      <ProductForm
        :product="product"
        :action="adminProductsPath()"
        method="post"
        submit-label="Create product"
      />
    </template>
  </UDashboardPanel>
</template>
